import React from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

const MarkdownMessage = ({ content, className }) => {
  const createMarkup = (markdownText) => {
    const rawHtml = marked.parse(markdownText);
    const cleanHtml = DOMPurify.sanitize(rawHtml);
    return { __html: cleanHtml };
  };

  return (
    <div className={className} dangerouslySetInnerHTML={createMarkup(content)}></div>
  );
};

export default MarkdownMessage;
